import CorrectiveActionForm from './CorrectiveActionForm'
export default CorrectiveActionForm
